<template>
  <div class="main-body">
    <div class="header">科室管理</div>
    <div class="out">

      <div class="search2">

        <div style="float:right;">
          <el-input size="mini" placeholder="请输入科室" v-model="name" clearable style="width:200px;margin-right:10px"></el-input>
          <el-button size="mini" plain type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="loading" :data="tableData" :height="th" border>

        <el-table-column prop="name" label="科室名称" fixed width="200"></el-table-column>
        <el-table-column prop="sort" label="排序" ></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

  </div>
</template>

<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{

      name:'',

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      showModalAdd:false,
      showModalEdit:false,

      th:0,

      loading:false,

    }
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;
  },
  components:{

  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    search(){
      this.currentPage = 1;
      this.getList();
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      let that = this;

      that.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Department/GovPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          name:this.name,
        }
      }).then( (response)=> {
        //console.log(response);
        that.loading = false;

        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        that.loading = false;
        console.log(error);
      });
    },

  }
}
</script>

